/* core-multibuy.js — Multibuy sticker panel. Core Appliances.
   Reads the bundle data from #core-multibuy-data and fills #core-mb-panel.
   Safe to load more than once. */
(function () {
  if (window.__coreMultibuy) return;
  window.__coreMultibuy = true;

  var DATA = null;
  var lastFocus = null;

  function data() {
    if (DATA) return DATA;
    var el = document.getElementById('core-multibuy-data');
    if (!el) return null;
    try { DATA = JSON.parse(el.textContent); } catch (e) { DATA = null; }
    return DATA;
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '£' + n.toLocaleString('en-GB', {
      minimumFractionDigits: n % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function panel() { return document.getElementById('core-mb-panel'); }

  function close() {
    var p = panel();
    if (!p || p.hidden) return;
    p.hidden = true;
    document.body.classList.remove('core-mb-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  function open(handle, count, trigger) {
    var all = data();
    var p = panel();
    if (!all || !p || !all[handle]) return false;
    var b = all[handle];

    p.querySelector('.core-mb__title').textContent = b.t;

    var img = p.querySelector('.core-mb__media img');
    if (b.img) { img.src = b.img; img.alt = b.t; img.parentNode.hidden = false; }
    else { img.removeAttribute('src'); img.parentNode.hidden = true; }

    var n = (b.items || []).length;
    p.querySelector('.core-mb__lede').textContent =
      'This product is also sold as part of a bundle. Buy all ' + n +
      ' together as one order and the price drops.';

    var ul = p.querySelector('.core-mb__items');
    ul.innerHTML = '';
    (b.items || []).forEach(function (it) {
      var li = document.createElement('li');
      var s = document.createElement('span');
      s.textContent = it.t;
      var pr = document.createElement('b');
      pr.textContent = (it.f ? 'from ' : '') + money(it.p);
      li.appendChild(s);
      li.appendChild(pr);
      ul.appendChild(li);
    });

    p.querySelector('.core-mb__sep span').textContent = money(b.w);
    p.querySelector('.core-mb__price span').textContent = money(b.p);
    p.querySelector('.core-mb__save').textContent = 'You save ' + money(b.s);

    var cta = p.querySelector('.core-mb__cta');
    cta.setAttribute('href', '/products/' + handle);

    var more = p.querySelector('.core-mb__more');
    var extra = (parseInt(count, 10) || 1) - 1;
    if (extra > 0) {
      more.textContent = extra === 1
        ? 'This product is in one other bundle too — see all of them in Bundles and Complete Sets.'
        : 'This product is in ' + extra + ' other bundles too — see all of them in Bundles and Complete Sets.';
      more.hidden = false;
    } else {
      more.hidden = true;
    }

    lastFocus = trigger || null;
    p.hidden = false;
    document.body.classList.add('core-mb-open');
    var x = p.querySelector('.core-mb__x');
    if (x) x.focus();
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mb-open]') : null;
    if (btn) {
      var handle = btn.getAttribute('data-mb-open');
      if (open(handle, btn.getAttribute('data-mb-count'), btn)) {
        e.preventDefault();
        e.stopPropagation();
      } else {
        // No data on this page: fall back to the bundle page itself.
        window.location.href = '/products/' + handle;
      }
      return;
    }
    if (e.target.closest && e.target.closest('[data-mb-close]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) close();
  });
})();
